// extracted by mini-css-extract-plugin
module.exports = {"card":"SNK8F"};